import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link as GatsbyLink } from '@gatsbyjs/reach-router';

import i18nContext from './i18nContext';
import { getLanguagePrefix } from '@helpers';

const Link = forwardRef(
  Object.assign(({ to, children, target, translate, ...rest }, ref) => {
    const { lng } = useContext(i18nContext);
    const external = /^http/gi.test(to) || /^tel:/m.test(to);
    const t = !(translate && translate === 'false');

    if (external || target) {
      return (
        <a
          href={!external && t ? `${getLanguagePrefix(lng)}${to}` : to}
          target={target}
          ref={ref}
          {...rest}
        >
          {children}
        </a>
      );
    }
    return (
      <GatsbyLink
        to={t ? `${getLanguagePrefix(lng)}${to}` : to}
        ref={ref}
        {...rest}
      >
        {children}
      </GatsbyLink>
    );
  }),
  { displayName: 'Link' }
);

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Link;
